/* Ascendia product page, round 3 - 7 Oct 2026 (tools/pdp-round3-7oct2026/REPORT.md). ~3 KB. Never throws.
   1. HEIGHT + WEIGHT BOX ALWAYS OPEN (Majed: "customers are lazy, no extra tap"). snippets/asc-pdp-r3.liquid opens it before
      the first paint; this keeps it open (a tap or Enter on its title cannot fold it), puts "Height" / "Weight" in the empty
      boxes, and switches to the two-box layout when ft+in / lb / st is chosen.
   2. THE ANSWER WRITES THE SIZE. When she has TYPED both numbers and the engine (assets/asc-size-guide.js) shows
      "Choose L", L is chosen for her: after a 1.2 s pause, on Done / Enter, or when she leaves the box. It presses the
      engine's own button, so assets/asc-pdp-r2.js counts it as her choice (ADD TO CART unlocks) exactly like a tap.
      Numbers remembered from an earlier visit only SUGGEST (no size is ever pre-selected without her action).
      The button then reads "L selected" with a tick. With the iPhone keyboard open the box is kept in view above it.
   3. BACK TO THE COLLECTION. The hidden link printed by the snippet becomes a pill on the photo (phone) or a quiet line
      above the title (desktop). Coming from a collection page of this store, it goes Back (filters + scroll kept). */
(function () {
  'use strict';
  if (window.__ascR3) return; window.__ascR3 = 1;
  var d = document;
  var ar = (d.documentElement.lang || '').indexOf('ar') === 0;
  var T = ar ? { done: 'تم اختيار المقاس %S' } : { done: '%S selected' };

  /* ---------- 1 + 2. the size box ---------- */
  function fit() {
    var wraps = Array.prototype.slice.call(d.querySelectorAll('details[data-asc-sg-quickwrap]'));
    wraps.forEach(function (w) {
      if (w.__r3) return; w.__r3 = 1;
      w.open = true; w.classList.add('asc-r3');
      w.addEventListener('toggle', function () { if (!w.open) w.open = true; });
      var sum = w.querySelector('summary');
      if (sum) { sum.setAttribute('tabindex', '-1'); sum.addEventListener('click', function (e) { e.preventDefault(); }); }
      var quick = w.querySelector('[data-asc-sg-quick]');
      var form = quick && quick.querySelector('[data-asc-sg-form]');
      if (!form) return;
      /* labels -> placeholders (metric boxes only) */
      form.querySelectorAll('.asc-sg__field--u').forEach(function (f) {
        var lab = f.querySelector('.asc-sg__field-head > span:first-child');
        var inp = f.querySelector(':scope > input');
        if (lab && inp && !inp.placeholder) inp.placeholder = lab.textContent.trim();
        var sel = f.querySelector('select');
        var mode = function () { var pairOn = !!f.querySelector('.asc-sg__pair:not([hidden])'); f.classList.toggle('asc-r3-pair', pairOn); };
        mode();
        if (sel) sel.addEventListener('change', function () { setTimeout(mode, 0); });
      });
      var btn = form.querySelector('[data-asc-sg-choose]');
      var res = form.querySelector('[data-asc-sg-result]');
      var typed = false, timer = null;
      function current() {
        var c = d.querySelector('section[id^="MainProduct-"] variant-radios .asc-size-fs input[type="radio"]:checked');
        return c ? c.value : null;
      }
      function picked() { var s = d.querySelector('section[id^="MainProduct-"]'); return !!(s && !s.classList.contains('asc-nosize-sec')); }
      function allFilled() {
        var boxes = Array.prototype.filter.call(form.querySelectorAll('.asc-sg__fields input[name]'), function (x) { return x.offsetParent !== null && !x.closest('.asc-sg__field--opt'); });
        return boxes.length > 0 && boxes.every(function (x) { return x.value.trim() !== ''; });
      }
      function mark() {
        if (!btn) return;
        var s = btn.getAttribute('data-size');
        var on = !!(!btn.hidden && s && picked() && current() === s);
        var was = btn.classList.contains('asc-r3-done');
        if (on && !was) btn.__r3t = btn.textContent;
        if (!on && was && btn.__r3t) btn.textContent = btn.__r3t;
        btn.classList.toggle('asc-r3-done', on);
        if (on) { btn.textContent = T.done.replace('%S', s); btn.setAttribute('aria-pressed', 'true'); }
        else btn.removeAttribute('aria-pressed');
      }
      function tryPick() {
        clearTimeout(timer);
        if (!typed || !btn || btn.hidden || !res || res.hidden || !allFilled()) return;
        var s = btn.getAttribute('data-size');
        if (!s) return;
        if (picked() && current() === s) { mark(); return; }
        btn.click();
        setTimeout(mark, 150); setTimeout(mark, 900);
      }
      form.addEventListener('input', function () {
        typed = true;
        if (btn) btn.classList.remove('asc-r3-done');
        clearTimeout(timer); timer = setTimeout(tryPick, 1200);
      });
      form.addEventListener('keydown', function (e) { if (e.key === 'Enter') setTimeout(tryPick, 30); });
      form.addEventListener('focusout', function () { setTimeout(function () { if (!form.contains(d.activeElement)) tryPick(); }, 60); });
      /* keyboard open (iPhone): keep the boxes + the answer line above the keyboard */
      form.addEventListener('focusin', function (e) {
        if (!e.target || e.target.tagName !== 'INPUT' || window.innerWidth >= 750) return;
        setTimeout(function () {
          var vv = window.visualViewport, vh = vv ? vv.height : window.innerHeight;
          var r = form.getBoundingClientRect();
          var top = 84;                                   /* under the sticky header */
          if (r.top < top || r.top + 130 > vh) window.scrollBy({ top: r.top - top, behavior: 'smooth' });
        }, 350);
      });
      if (btn) btn.addEventListener('click', function () { setTimeout(mark, 150); });
      /* a size tapped by hand: the button tells the truth again (or confirms the same size) */
      var sec = d.querySelector('section[id^="MainProduct-"]');
      if (sec) sec.addEventListener('change', function () { setTimeout(mark, 80); });
    });
  }

  /* ---------- 3. back to the collection ---------- */
  function back() {
    var a = d.querySelector('a.asc-r3-back');
    if (!a) return;
    var map = {};
    try { map = JSON.parse(a.getAttribute('data-asc-r3-map') || '{}'); } catch (e) { map = {}; }
    var ref = null;
    try { ref = d.referrer ? new URL(d.referrer) : null; } catch (e) { ref = null; }
    var fromList = false;
    if (ref && ref.origin === location.origin && /\/collections\/[^/]+\/?$/.test(ref.pathname)) {
      var h = ref.pathname.replace(/\/$/, '').split('/').pop();
      if (map[h]) {
        a.querySelector('.asc-r3-back__t').textContent = map[h];
        a.setAttribute('aria-label', (ar ? 'العودة إلى ' : 'Back to ') + map[h]);
        a.href = ref.pathname + ref.search;
        fromList = true;
      }
    }
    a.addEventListener('click', function (e) {
      if (fromList && history.length > 1) { e.preventDefault(); history.back(); }
    });
    var phone = window.matchMedia('(max-width: 749px)').matches;
    if (phone) {
      var ul = d.querySelector('.product__media-wrapper .product__media-list');
      var host = ul && ul.parentNode;
      if (!host) return;
      if (window.getComputedStyle(host).position === 'static') host.style.position = 'relative';
      a.classList.add('asc-r3-back--pill');
      host.appendChild(a);
      /* always the side AWAY from the "1 / 7" counter (in Arabic the gallery strip keeps the counter on the right too) */
      var place = function () {
        var c = host.querySelector('.asc-g-count'), hr = host.getBoundingClientRect();
        var right = false;
        if (c && c.offsetWidth) { var cr = c.getBoundingClientRect(); right = (cr.left + cr.width / 2) < (hr.left + hr.width / 2); }
        a.style.insetInlineStart = 'auto'; a.style.left = right ? 'auto' : '1.2rem'; a.style.right = right ? '1.2rem' : 'auto';
      };
      place(); setTimeout(place, 600);
    } else {
      var ol = d.querySelector('nav.breadcrumbs .breadcrumbs__list');
      var items = ol ? ol.querySelectorAll(':scope > .breadcrumbs__item') : [];
      if (ol && items.length === 2) {
        var li = d.createElement('li'); li.className = 'breadcrumbs__item';
        var la = d.createElement('a'); la.className = 'breadcrumbs__link'; la.href = a.href;
        la.textContent = a.querySelector('.asc-r3-back__t').textContent;
        la.addEventListener('click', function (e) { if (fromList && history.length > 1) { e.preventDefault(); history.back(); } });
        li.appendChild(la); ol.insertBefore(li, items[1]);
        return;
      }
      if (ol) return;                                    /* the theme already shows a shelf in its breadcrumb */
      var title = d.querySelector('section[id^="MainProduct-"] .product__title');
      if (!title) return;
      a.classList.add('asc-r3-back--crumb');
      title.parentNode.insertBefore(a, title);
    }
    a.hidden = false;
  }

  function boot() {
    try { fit(); } catch (e) { /* never break the page */ }
    try { back(); } catch (e) { /* idem */ }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
